var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecruitFab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "180 620 33 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "205.58 621.98 177.1 643.59 186.1 643.59 196.58 633.98 188.52 646.41 191.07 653.73 196.52 644.41 205.97 650.41 205.58 621.98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitFab);
export default __webpack_public_path__ + "static/media/recruit-fab.418708d155b2ba264b127c344143784b.svg";
export { ForwardRef as ReactComponent };